import type { RouteLocationNormalized } from "vue-router";

export default [
  {
    path: "/backoffice/organization/currency-configuration",
    name: "CurrencyConfiguration",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Currency Configuration" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Organization/CurrencyConfiguration.vue"
      ),
  },
  {
    path: "/backoffice/organization/manage-employees",
    name: "ManageEmployees",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Employees" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Employee/ManageEmployees.vue"
      ),
  },
  {
    path: "/backoffice/employee/:id",
    name: "EmployeeDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Employees", to: "/backoffice/organization/manage-employees" },
        { label: "Employee Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Employee/EmployeeDetail.vue"
      ),
  },
  {
    path: "/backoffice/employee/create",
    name: "CreateEmployee",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Employees", to: "/backoffice/organization/manage-employees" },
        { label: "Create Employee" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Employee/CreateEmployee.vue"
      ),
  },
  {
    path: "/backoffice/organization/manage-locations",
    name: "ManageLocations",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Locations" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Offices/ManageLocations.vue"
      ),
  },
  {
    path: "/backoffice/organization/manage-holidays",
    name: "ManageHolidays",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Holidays" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Organization/ManageHolidays.vue"
      ),
  },
  {
    path: "/backoffice/organization/self-service",
    name: "SelfServiceList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Self Service" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Organization/SelfServiceList.vue"
      ),
  },
  {
    path: "/backoffice/organization/self-service/create",
    name: "SelfServiceCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Self Service", to: "/backoffice/organization/self-service" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Organization/SelfServiceCreate.vue"
      ),
  },
  {
    path: "/backoffice/organization/self-service/:id",
    name: "SelfServiceDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Self Service", to: "/backoffice/organization/self-service" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Organization/SelfServiceCreate.vue"
      ),
  },
  {
    path: "/backoffice/offices/create",
    name: "CreateLocation",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Locations", to: "/backoffice/organization/manage-locations" },
        { label: "Create Location" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Offices/CreateLocation/CreateLocation.vue"
      ),
  },
  {
    path: "/backoffice/offices/:id",
    name: "LocationDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Locations", to: "/backoffice/organization/manage-locations" },
        { label: "Location Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Offices/LocationDetail.vue"
      ),
  },
  {
    path: "/backoffice/offices/:id/edit",
    name: "EditLocation",
    meta: {
      requiresAuth: true,
      breadcrumb: (route: RouteLocationNormalized) => [
        { label: "BackOffice", to: "/" },
        { label: "Organization" },
        { label: "Locations", to: "/backoffice/organization/manage-locations" },
        { label: "Location Detail", to: `/backoffice/offices/${route.params.id}` },
        { label: "Edit Location" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "organization" */ "@/views/backoffice/Offices/EditLocation.vue"
      ),
  }
];
